export var IconToggleLabelPlacement;
(function (IconToggleLabelPlacement) {
    IconToggleLabelPlacement["START"] = "start";
    IconToggleLabelPlacement["END"] = "end";
})(IconToggleLabelPlacement || (IconToggleLabelPlacement = {}));
//# sourceMappingURL=types.js.map